import { fetch } from '@ixigo/shell/fetch';

import type {
	BankRedirectionResponse,
	BankRedirectionResponseEnvelope,
} from '../types';

/**
 * Bank redirect for approved users (CVP `userFlow === "APPROVED"` /
 * "APPROVED_NO_POPUP"). Returns the card-management surface URL — handled as a
 * plain GET redirect to `redirectUrl` (see `redirect-to-bank`). Unwraps the
 * `data` envelope.
 */
export async function fetchManageCard(): Promise<BankRedirectionResponse> {
	const response: BankRedirectionResponseEnvelope = await fetch
		.get('fintech/v1/hf/manage/card')
		.json();
	return response.data;
}
